/// <amd-module name="VSS/Ext/Components/ExternalNavigation/ExternalNavigation" />
import * as React from "react";

import { ExternalContent } from "VSS/Ext/ExternalContent";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { Components, VssComponent } from "VSS/Platform/Layout";
import { IVssNavigationService } from "VSS/Platform/Navigation";
import { IVssPerformanceService } from "VSS/Platform/Performance";
import { Uri } from "VSS/Platform/Util/Url";

/**
 * ExternalNavigation component which shows a navigation contribution in an ExternalContent host
 */
class ExternalNavigation extends VssComponent {
    private _ttiMarked: boolean = false;
    private _contributionId: string;

    public render(): JSX.Element | null {
        let key: string | undefined;
        let customUri: string | undefined;

        const navService = this.context.pageContext.getService<IVssNavigationService>("IVssNavigationService");
        const displayedNavs = navService.getDisplayedNavigation();
        if (displayedNavs && displayedNavs.length) {
            const displayedNav = navService.getNavigation(displayedNavs[displayedNavs.length - 1]);
            if (displayedNav) {
                this._contributionId = displayedNav.id;
                key = displayedNav.id;

                // Forward any query string parameters from the host frame URL into the navigation iframe URL
                if (window.location.search) {
                    // Grab the navigation contribution "uri" property and add the current page's query parameters to it
                    const contributionService = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
                    const navContribution = contributionService.getContribution<{ uri: string }>(displayedNav.id);
                    if (navContribution && navContribution.uri) {
                        const navUri = new Uri(navContribution.uri);
                        const pageUri = new Uri(window.location.href);
                        for (const param of pageUri.queryParameters) {
                            navUri.addQueryParam(param.name, param.value);
                        }
                        customUri = navUri.absoluteUri;
                    }
                }
            }
        }

        return this._contributionId ? (
            <ExternalContent
                className="navigation-content flex-grow"
                contributionId={this._contributionId}
                contributionUri={customUri}
                key={key}
                onLoaded={this.onLoaded}
            />
        ) : null;
    }

    private onLoaded = () => {
        if (!this._ttiMarked) {
            const performanceService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
            performanceService.markTimeToInteractive("Extentions", "Extension.Navigation." + this._contributionId);
        }
    };
}

Components.add("vss-ext.ExternalNavigation", ExternalNavigation);
